import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import VersionInfo from 'src/assets/version.json';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-about',
  templateUrl: './about.component.html',
  styleUrls: ['./about.component.scss'],
})
export class AboutComponent implements OnInit {
  public version: string = VersionInfo.version;
  public currentYear: number = new Date().getFullYear();
  public environmentName: string = environment.envName;

  constructor(private readonly titleService: Title) {}

  ngOnInit(): void {
    this.titleService.setTitle('About - Vision');
  }
}
